// API response handler
const handleResponse = async (response) => {
    // Check for new tokens in headers
    const newAccessToken = response.headers.get('New-Access-Token');
    const newRefreshToken = response.headers.get('New-Refresh-Token');
    
    if (newAccessToken && newRefreshToken) {
        // Update the stored tokens
        localStorage.setItem('token', newAccessToken);
        localStorage.setItem('refreshToken', newRefreshToken);
    }
    
    return response;
};

// Make authenticated API request
export const makeAuthenticatedRequest = async (url, options = {}) => {
    const token = localStorage.getItem('token');
    const refreshToken = localStorage.getItem('refreshToken');
    
    const headers = {
        ...options.headers,
        'Authorization': `Bearer ${token}`,
        'Refresh-Token': refreshToken
    };
    
    const response = await fetch(url, { ...options, headers });
    return handleResponse(response);
};

// ⚠️ WARNING: DO NOT USE THIS API_BASE_URL - IT HAS THE WRONG PORT!
// ⚠️ Use API_BASE_URL from '../config' instead (port 5001)
// ⚠️ This is kept only for legacy compatibility and will be removed
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'; 